module.exports = __webpack_public_path__ + "static/media/favicon.3a54a757.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/branding/tellit/favicon.ico
// module id = 1388
// module chunks = 0